import Tags from "./Tags";
import List from "./List";
import Edit from "./Edit";
export default {
    Tags,
    List,
    Edit
}